<template>
  <div class="crud_form_wrapper">
    <div
      class="form_title_wrapper d-flex align-items-center justify-content-between"
    >
      <h4>{{ $t("PLACEHOLDERS.return_request_details") }}</h4>
      <v-btn @click="$router.go(-1)" style="color: #e1423d">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>

    <div class="single_step_form_content_wrapper" v-if="!isWaitingRequest">
      <div class="row">
        <base-input
          col="6"
          type="text"
          :placeholder="$t('PLACEHOLDERS.return_number')"
          v-model.trim="data.return_number"
          disabled
        />
        <base-input
          col="6"
          type="text"
          :placeholder="$t('PLACEHOLDERS.order_number')"
          v-model.trim="data.order_number"
          disabled
        />
        <base-input
          col="6"
          type="text"
          :placeholder="$t('PLACEHOLDERS.customer_name')"
          v-model.trim="data.customer_name"
          disabled
        />
        <base-input
          col="6"
          type="text"
          :placeholder="$t('PLACEHOLDERS.phone')"
          v-model.trim="data.customer_phone"
          disabled
        />
        <base-input
          col="6"
          type="text"
          :placeholder="$t('PLACEHOLDERS.status')"
          v-model.trim="data.status_label"
          disabled
        />
        <base-input
          col="6"
          type="text"
          :placeholder="$t('PLACEHOLDERS.created_at')"
          v-model.trim="data.created_at"
          disabled
        />
        <base-input
          col="12"
          type="textarea"
          :placeholder="$t('PLACEHOLDERS.return_request_reason')"
          v-model.trim="data.reason"
          disabled
        />
        <base-input
          col="6"
          type="text"
          :placeholder="$t('PLACEHOLDERS.return_request_rejection_reason')"
          v-model.trim="data.rejection_reason"
          disabled
        />
        <base-input
          col="6"
          type="text"
          :placeholder="$t('PLACEHOLDERS.return_request_cancellation_reason')"
          v-model.trim="data.cancellation_reason"
          disabled
        />
        <base-input
          col="6"
          type="text"
          :placeholder="$t('PLACEHOLDERS.return_request_processed_by')"
          v-model.trim="data.processed_by"
          disabled
        />
        <base-input
          col="6"
          type="text"
          :placeholder="$t('PLACEHOLDERS.return_request_processed_at')"
          v-model.trim="data.processed_at"
          disabled
        />

        <div class="col-12 mt-4" v-if="data.images?.length">
          <h5 class="mb-3">{{ $t("PLACEHOLDERS.return_request_images") }}</h5>
          <div class="d-flex flex-wrap" style="gap: 12px">
            <a
              v-for="(image, index) in data.images"
              :key="index"
              :href="image"
              target="_blank"
              class="border rounded overflow-hidden"
              style="
                width: 120px;
                height: 120px;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                background: #f8f9fa;
              "
            >
              <img
                :src="image"
                alt="return-request"
                style="width: 100%; height: 100%; object-fit: cover"
              />
            </a>
          </div>
        </div>

        <div class="col-12 mt-5" v-if="data.items?.length">
          <h5 class="mb-3">{{ $t("PLACEHOLDERS.return_request_items") }}</h5>
          <div class="table-responsive">
            <table class="table table-bordered text-center align-middle">
              <thead>
                <tr>
                  <th>#</th>
                  <th>{{ $t("PLACEHOLDERS.productName") }}</th>
                  <th>{{ $t("PLACEHOLDERS.quantity") }}</th>
                  <th>{{ $t("PLACEHOLDERS.riyal_price") }}</th>
                  <th>{{ $t("PLACEHOLDERS.riyal_total_price") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in data.items"
                  :key="item.order_item_id || index"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ item?.product?.name || "-" }}</td>
                  <td>{{ item?.quantity ?? "-" }}</td>
                  <td>{{ item?.unit_price ?? "-" }}</td>
                  <td>{{ item?.total_price ?? "-" }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="col-12 mt-5">
          <div class="d-flex flex-wrap align-items-center" style="gap: 12px">
            <v-btn
              v-for="action in availableActions"
              :key="action.status"
              :color="action.color"
              dark
              @click="openStatusDialog(action.status)"
            >
              {{ action.label }}
            </v-btn>
          </div>
        </div>
      </div>
    </div>

    <div class="text-center my-10" v-else>
      <v-progress-circular indeterminate color="#E1423D"></v-progress-circular>
    </div>

    <v-dialog v-model="dialogStatus" max-width="640px">
      <v-card>
        <v-card-title class="text-h5 justify-center">
          {{ $t("PLACEHOLDERS.return_request_change_status") }}
        </v-card-title>
        <v-card-text>
          <p class="text-center mb-4">
            {{ getStatusDialogText(selectedStatus) }}
          </p>

          <base-input
            v-if="requiresReason(selectedStatus)"
            col="12"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.reason')"
            v-model.trim="statusForm.reason"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="modal_confirm_btn"
            :loading="isSubmitting"
            @click="confirmStatusChange"
          >
            {{ $t("BUTTONS.save") }}
          </v-btn>
          <v-btn class="modal_cancel_btn" @click="closeStatusDialog">
            {{ $t("BUTTONS.cancel") }}
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "ShowReturnRequest",

  data() {
    return {
      isWaitingRequest: false,
      isSubmitting: false,
      dialogStatus: false,
      selectedStatus: null,
      data: {
        id: null,
        return_number: null,
        order_number: null,
        customer_name: null,
        customer_phone: null,
        status: null,
        status_label: null,
        reason: null,
        rejection_reason: null,
        cancellation_reason: null,
        images: [],
        items: [],
        processed_by: null,
        processed_at: null,
        created_at: null,
      },
      statusForm: {
        reason: null,
      },
    };
  },

  computed: {
    availableActions() {
      const status = this.data?.status;

      if (status === "pending_review") {
        return [
          {
            status: "accepted",
            label: this.$t("STATUS.accepted"),
            color: "success",
          },
          {
            status: "rejected",
            label: this.$t("STATUS.rejected"),
            color: "error",
          },
          {
            status: "cancelled",
            label: this.$t("STATUS.cancelled"),
            color: "warning",
          },
        ];
      }

      if (status === "accepted") {
        return [
          {
            status: "on_the_way",
            label: this.$t("STATUS.on_the_way"),
            color: "primary",
          },
        ];
      }

      if (status === "on_the_way") {
        return [
          {
            status: "received",
            label: this.$t("STATUS.received"),
            color: "success",
          },
        ];
      }

      if (status === "received") {
        return [
          {
            status: "completed",
            label: this.$t("STATUS.completed"),
            color: "success",
          },
        ];
      }

      return [];
    },
  },

  methods: {
    requiresReason(status) {
      return ["rejected", "cancelled"].includes(status);
    },

    getStatusDialogText(status) {
      if (status === "accepted") return this.$t("STATUS.accepted");
      if (status === "on_the_way") return this.$t("STATUS.on_the_way");
      if (status === "received") return this.$t("STATUS.received");
      if (status === "completed") return this.$t("STATUS.completed");
      if (status === "rejected") return this.$t("STATUS.rejected");
      if (status === "cancelled") return this.$t("STATUS.cancelled");
      return "-";
    },

    openStatusDialog(status) {
      this.selectedStatus = status;
      this.statusForm.reason = null;
      this.dialogStatus = true;
    },

    closeStatusDialog() {
      this.dialogStatus = false;
      this.selectedStatus = null;
      this.statusForm.reason = null;
    },

    async fetchReturnRequest() {
      this.isWaitingRequest = true;

      try {
        const response = await this.$axios({
          method: "GET",
          url: `return-requests/${this.$route.params?.id}`,
        });

        const payload = response?.data?.data ?? response?.data ?? {};

        this.data = {
          ...this.data,
          id: payload?.id ?? null,
          return_number: payload?.return_number ?? null,
          order_number: payload?.order_number ?? null,
          customer_name: payload?.user?.name ?? null,
          customer_phone: payload?.user?.phone ?? null,
          status: payload?.status ?? null,
          status_label:
            payload?.status_label ?? this.$t(`STATUS.${payload?.status}`),
          reason: payload?.reason ?? null,
          rejection_reason: payload?.rejection_reason ?? null,
          cancellation_reason: payload?.cancellation_reason ?? null,
          images: payload?.images ?? [],
          items: payload?.items ?? [],
          processed_by: payload?.processed_by ?? null,
          processed_at: payload?.processed_at ?? null,
          created_at: payload?.created_at ?? null,
        };
      } catch (error) {
        console.log(error?.response?.data?.message);
      } finally {
        this.isWaitingRequest = false;
      }
    },

    async confirmStatusChange() {
      if (this.requiresReason(this.selectedStatus) && !this.statusForm.reason) {
        this.$message.error(this.$t("VALIDATION.reason_required"));
        return;
      }

      this.isSubmitting = true;

      try {
        const response = await this.$axios({
          method: "PATCH",
          url: `return-requests/${this.$route.params?.id}/status`,
          data: {
            status: this.selectedStatus,
            reason: this.statusForm.reason,
          },
        });

        const payload = response?.data?.data ?? response?.data ?? {};
        const status = payload?.status ?? this.selectedStatus;

        this.data.status = status;
        this.data.status_label =
          payload?.status_label ?? this.$t(`STATUS.${status}`);
        this.data.processed_by =
          payload?.processed_by ?? this.data.processed_by;
        this.data.processed_at =
          payload?.processed_at ?? this.data.processed_at;
        this.data.rejection_reason =
          payload?.rejection_reason ?? this.data.rejection_reason;
        this.data.cancellation_reason =
          payload?.cancellation_reason ?? this.data.cancellation_reason;

        this.$message.success(
          response?.data?.message || this.$t("MESSAGES.editedSuccessfully")
        );
        this.closeStatusDialog();
      } catch (error) {
        this.$message.error(error?.response?.data?.message);
      } finally {
        this.isSubmitting = false;
      }
    },
  },

  created() {
    this.fetchReturnRequest();
  },
};
</script>
